import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/home',
        name: 'home',
        component: () => import("./views/home.vue")
    }
];

export default routes;
